import React, { useState, useEffect } from "react";
import supabase from "../utils/supabase";
import { useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";

function Threelogin() {
  const navigate = useNavigate();
  const [session, setSession] = useState(null);
  const [loading, isLoading] = useState(false);
  const options = [
    {
      title: "Startup Founder",
      description: "Looking to raise funds and grow your startup.",
    },
    {
      title: "Investor",
      description: "Seeking to invest in innovative startups.",
    },
    {
      title: "Service Provider",
      description: "Offering essential services to support startups.",
    },
  ];

  const handlePreference = async (option) => {
    console.log(option);
    console.log(session);
    isLoading(true);
    //set the role of the user in the database
    const { data, error } = await supabase
      .from("users")
      .update({ role: option })
      .eq("id", session.user.id);
    if (error) {
      console.log(error);
    } else {
      navigate("/social");
      isLoading(false);
    }
  };

  useEffect(() => {
    // Get initial session
    const getInitialSession = async () => {
      const {
        data: { session },
        error,
      } = await supabase.auth.getSession();
      if (error) {
        console.error("Error fetching session:", error.message);
      } else {
        setSession(session);
      }
    };

    getInitialSession();
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-tr from-[#0072ff] to-[#003f7f] text-white p-6">
      {/*Loader */}
      {loading && (
        <div className="fixed top-0 left-0 z-50 w-full h-full flex flex-col items-center justify-center bg-black bg-opacity-50">
          <HashLoader color="#0072ff" size={50} />
          <p className="text-white mt-4">Loading...</p>
        </div>
      )}

      {/* Welcome Section */}
      <div className="text-center mb-12">
        <p className="text-lg font-bold md:text-xl text-gray-200">
          Choose an option that best describes you to get started.
        </p>
      </div>

      {/* Options Section */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 w-full max-w-4xl">
        {options.map((option, index) => (
          <div
            key={index}
            className="bg-white/10 p-6 rounded-lg shadow-lg hover:shadow-2xl transition-all transform hover:scale-105 text-center cursor-pointer"
            onClick={() => handlePreference(option.title)}
          >
            <h2 className="text-2xl font-bold mb-2">
              {`I am a ${option.title}`}
            </h2>
            <p className="text-base text-gray-300">{option.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Threelogin;
